import { animate, state, style, transition, trigger } from "@angular/animations";

export const actionsNavAnimation = trigger("actions-nav", [
  state("collapsed", style({ width: "0px", opacity: 0, overflow: "hidden" })),
  state("expanded", style({ width: "425px", opacity: 1 })),
  transition("collapsed <=> expanded", animate("250ms ease-in-out")),
]);
